/* global wp */
import { get } from 'lodash';
import EmailField from '../elements/fields/email-field';
import PasswordField from '../elements/fields/password-field';
import AuthForm from './../elements/auth-form';
import Notice from './../elements/notice';
import Button from '../elements/button';
import { __ } from '@wordpress/i18n';
import CheckboxInput from '../elements/fields/checkbox-input';

const { useState } = wp.element;

const LoginForm = () => {
	const [email, setEmail] = useState(
		get(window, 'hubConnectorVars.last_user', '')
	);
	const [pwd, setPwd] = useState('');
	const [validEmail, setEmailValidation] = useState(false);
	const [validPwd, setPwdValidation] = useState(false);

	const authErr = get(window, 'hubConnectorVars.auth_error', '');

	return (
		<AuthForm
			action={get(window, 'hubConnectorVars.login.hub_auth_url', '')}
		>
			<EmailField
				label={__('Email', 'wpmudev')}
				placeholder={__('johndoe@mail.com', 'wpmudev')}
				autoFocus={true}
				value={email}
				name="username"
				required="required"
				onInput={(val) => setEmail(val)}
				onError={(val) => setEmailValidation(!val)}
			/>
			<PasswordField
				label={__('Password', 'wpmudev')}
				placeholder="**********"
				name="password"
				required="required"
				value={pwd}
				onInput={(val) => setPwd(val)}
				onError={(val) => setPwdValidation(!val)}
			/>

			{authErr && (
				<Notice>
					<p dangerouslySetInnerHTML={{ __html: authErr }}></p>
				</Notice>
			)}

			<Button
				className="dashui-button"
				type="submit"
				disabled={!validEmail || !validPwd || !email || !pwd}
			>
				{__('Login', 'wpmudev')}
			</Button>

			<div className="dashui-auth-form-footer">
				<CheckboxInput>{__('Keep me logged in')}</CheckboxInput>
				<a
					target="_blank"
					href={get(window, 'hubConnectorVars.login.forgot_url', '')}
					rel="noreferrer"
				>
					{__('Forgot password?')}
				</a>
			</div>
		</AuthForm>
	);
};

export default LoginForm;
